// Client.js
// Redux Container for Client View

// Imports
import { connect } from 'react-redux';
import * as Action from '../actions/client';
import ClientView from '../components/ClientView/';

// State Mapper
const mapStateToProps = state => ({
  clients: state.client,
  products: state.product,
  order: state.order.current,
});

// Action Mapper
const mapDispatchToProps = dispatch => ({
  addClient: (name) => dispatch(Action.addClient(name)),
  renameClient: (id, name) => dispatch(Action.renameClient(id, name)),
  removeClient: (id) => dispatch(Action.removeClient(id)),
})

// Exports
export default connect(mapStateToProps, mapDispatchToProps)(ClientView);


// WEBPACK FOOTER //
// ./src/containers/Client.js